// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__t8KTe","rootMobile":"styles_rootMobile__10c2q"};